import ActionTypes from "./ActionTypes";

const get_cus_dashboard = (payload) => {
  return {
    type: ActionTypes.GET_CUS_DASHBOARD,
    payload: payload,
  };
};

const get_cus_assets = (payload) => {
  return {
    type: ActionTypes.GET_CUS_ASSETS,
    payload: payload,
  };
};

const get_cus_assetsDetail = (payload) => {
  return {
    type: ActionTypes.GET_CUS_ASSET_DETAIL,
    payload: payload,
  };
};

const cus_setAssetStatus = (payload) => {
  return {
    type: ActionTypes.SET_CUS_ASSETS_STATUS,
    payload,
  };
};

const cus_getUnlinkAssets = (payload) => {
  return {
    type: ActionTypes.CUS_GET_UNLINK_ASSETS,
    payload,
  };
};

export {
  get_cus_dashboard,
  get_cus_assets,
  get_cus_assetsDetail,
  cus_setAssetStatus,
  cus_getUnlinkAssets,
};
